import { ActionsPermission } from './app-permissoes.config';
import { PermissionModel } from './app-permission.model';
import { Injectable } from '@angular/core';

@Injectable()
export class PermissionService extends ActionsPermission {
    public permissoes: PermissionModel[];

    constructor() {
        super();
        this.permissoes = localStorage.getItem('permissionsAccounting') ? JSON.parse(localStorage.getItem('permissionsAccounting')) : [];
    }

    private instanceOfPermissoes(): void {
        this.permissoes = new Array<PermissionModel>();
    }

    private getActIndex(actionNumber: number): number {

        if (!this.permissoes)
            return -1;

        // Verifico na lista de permissão se existe o codigoMenuWeb
        let permissao = this.permissoes.filter((x) => x.codigoMenuWeb === actionNumber)[0];
        if (permissao !== undefined) {
            // Recebo a posição/indice da lista que se encontra o codigo menu web correspondente.
            let actIndex = this.permissoes.indexOf(permissao);
            return actIndex;
        }
        return -1;
    }

    public PermissionAcessar(act: number): boolean {
        // Pego apenas as propriedades do obj que corresponde ao codigoMenuWeb
        let perm = this.permissoes[this.getActIndex(act)];
        // Retorno true ou false de acordo com o valor da propriedade
        return perm === undefined || perm === null ? false : perm.acessar === 0 ? false : true;
        // return perm === undefined || perm === null ? false : perm.acessar;
    }

    public PermissionInserir(act: number): boolean {
        let perm = this.permissoes[this.getActIndex(act)];
        return perm === undefined || perm === null ? false : perm.inserir === 0 ? false : true;
    }

    public PermissionEditar(act: number): boolean {
        let perm = this.permissoes[this.getActIndex(act)];
        return perm === undefined || perm === null ? false : perm.editar === 0 ? false : true;
    }

    public PermissionExcluir(act: number): boolean {
        let perm = this.permissoes[this.getActIndex(act)];
        return perm === undefined || perm === null ? false : perm.excluir === 0 ? false : true;
    }

    public PermissionConsultar(act: number): boolean {
        let perm = this.permissoes[this.getActIndex(act)];
        return perm === undefined || perm === null ? false : perm.consultar === 0 ? false : true;
    }

    public GravaPermissoes(permissions: any[]): void {
        this.instanceOfPermissoes();
    }
}